import React from 'react';
import { convertMobileStyle } from 'src/helpers';

export const View = React.memo(({ style = {}, children, ...props }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        ...convertMobileStyle(style)
      }}
      {...props}
    >
      {children}
    </div>
  );
});
View.displayName = 'View';
